module.exports = __webpack_public_path__ + "img/valuable.fe76b314.svg";